module.exports = __webpack_public_path__ + "img/shop-icon.4d48ef6d.svg";